export function getGalleries (state){
  return state.galleries
}

export function getSelectedGallery (state){
  return state.selectedGallery
}